module.exports = __webpack_public_path__ + "static/img/logo.c09a01f4.svg";